import { render, staticRenderFns } from "./Referenceren.vue?vue&type=template&id=f2e32130&scoped=true"
import script from "./Referenceren.vue?vue&type=script&lang=js"
export * from "./Referenceren.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e32130",
  null
  
)

export default component.exports